<template>
  <div>
    <h2>{{recordTitle}}</h2>
    <b>{{recordTime}}</b>
    <i>{{recordCouponNimber}}</i>
    <i>{{recordOrderId}}</i>

    <div class="status" :class="{failed: orderFailed}">
      <b>{{recordStatusTitle}}<br class="status_wrap">{{recordStatusType}}</b>
      <p v-show="recordPoints !== ''"><strong>{{ recordPoints }}</strong></p>
      <em>{{recordStatusNote}}</em>
    </div>
  </div>
</template>

<script>

export default {
  name: 'myTransaction',
  props: {
    transactionData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      successStatusCode: [1000, 7000, 8000]
    }
  },
  computed: {
    // 標題
    recordTitle () {
      let title = ''
      const type = this.transactionData.order_type
      switch (type) {
        case 1:
          title = `加值點數 ${this.transactionData.points}點`
          break
        case 6:
          title = this.transactionData.area.display_name
          break
        case 7:
          title = `Google Play Points 兌換點數`
          break
        default:
          title = this.transactionData.channel.title
          break
      }
      return title
    },
    // 交易時間
    recordTime () {
      return this.convertUTCTimeToLocalTime(this.transactionData.created_at)
    },
    // 點數使用狀況 or 訂單編號
    recordCouponNimber () {
      // 是否要顯示點數使用狀況，不是則顯示訂單編號
      const isCouponPoint = {
        1: false,
        2: true,
        3: true,
        4: true,
        5: true,
        6: false,
        7: false
      }
      // 交易紀錄type
      const type = this.transactionData.order_type

      return isCouponPoint[type] ? this.getCouponPoint(this.transactionData) : `訂單編號：${this.transactionData.orderNumber}`
    },
    // 付款編號 or 禮品券序號 or 兌換編號 
    recordOrderId () {
      const recordStatusObj = {
        1: { orderTitle: '付款編號：', isTransactionId: true },
        2: { orderTitle: '兌換編號：', isTransactionId: false },
        3: { orderTitle: '禮品券序號：', isTransactionId: false },
        4: { orderTitle: '兌換編號：', isTransactionId: false },
        5: { orderTitle: '兌換編號：', isTransactionId: false },
        6: { orderTitle: '付款編號：', isTransactionId: true },
        7: { orderTitle: '付款編號：', isTransactionId: true }
      }
      // 交易紀錄type
      const type = this.transactionData.order_type

      // 編號數值，決定使用transactionId or orderNumber
      const serialNumber = recordStatusObj[type].isTransactionId ? this.transactionData.transactionId : this.transactionData.orderNumber

      return `${recordStatusObj[type].orderTitle}${serialNumber}`
    },
    // 交易成功 or 失敗
    orderFailed () {
      const statusCode = this.transactionData.statusCode
      if (this.successStatusCode.indexOf(statusCode) === -1) {
        return true
      } else {
        return false
      }
    },
     // type交易紀錄成功與否文案
    recordStatusTitle () {
      const recordStatusObj = {
        1: { 1000: '交易成功', err: '交易失敗' },
        2: { 7000: '兌換成功', err: '兌換失敗' },
        3: { 8000: '交易成功', err: '交易失敗' },
        4: { 7000: '兌換成功', err: '兌換失敗' },
        5: { 7000: '兌換成功', err: '兌換失敗' },
        6: { 7000: '訂閱成功', err: '訂閱失敗' },
        7: { 1000: '交易成功', err: '交易失敗' }
      }
      const type = this.transactionData.order_type
      const statusCode = this.transactionData.statusCode

      return recordStatusObj[type][statusCode] ? recordStatusObj[type][statusCode] : recordStatusObj[type].err
    },
    // 添加字串
    recordStatusType () {
      if (this.transactionData.order_type === 3 || this.transactionData.order_type === 4) {
        return '(贈禮)'
      }
      if (this.transactionData.order_type === 5) {
        return '(購買單集)'
      }
      return ''
    },
    // 點數判斷
    recordPoints () {
      const type = this.transactionData.order_type
      let points = ''
      switch (type) {
        // type 1 點數成功才顯示數值
        case 1: {
          const statusCode = this.transactionData.statusCode

          points = statusCode === 1000 ? `${this.transactionData.points} 點` : ''
          break
        }
        // type 6 如果isDiscount為true，則顯示首次優惠，否則顯示product/subscription_text
        case 6: {
          const isDiscount = this.transactionData.is_discount

          points = isDiscount ? `${this.transactionData.points} /首次優惠` : `${this.transactionData.points} / ${this.transactionData.product.subscription_text}`
          break
        }
        default: {
          points = `${this.transactionData.points} 點`
          break
        }
      }
      return points
    },
    //附註字樣
    recordStatusNote () {
      // type 5 顯示單集點數與集數
      if (this.transactionData.order_type === 5) {
        const episodesTotal = this.transactionData.episodes.length
        return `每集${this.transactionData.product.episodePoints}點 X ${episodesTotal}集`
      }
      // 其餘交易失敗顯示文案
      return this.orderFailed === true ? '請至APP更新交易狀態' : null
    }
  },
  methods: {
    convertUTCTimeToLocalTime: function (UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }
      function formatFunc (str) { // 格式化显示
        return str > 9 ? str : '0' + str
      }
      var date2 = new Date(UTCDateString) // 这步是关键
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      var hour = date2.getHours()
      // var noon = hour >= 12 ? 'PM' : 'AM';
      // hour = hour>=12?hour-12:hour;
      // hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes())
      var sec = formatFunc(date2.getSeconds())
      var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + sec
      return dateStr
    },
    getCouponPoint: function (transactionData) {
      if (transactionData.coupon === null) {
        return `點數使用狀況：錢包 ${transactionData.points}點`
      } else {
        const couponTypeObj = {
          2: `錢包${this.pointReset(transactionData.points - transactionData.coupon.points)}點 + 紅包${transactionData.coupon.points}點`,
          3: '紅包全額折抵',
          4: '紅包全額折抵',
          5: `錢包${this.pointReset(transactionData.points - transactionData.coupon.points)}點 + 紅包${transactionData.coupon.points}點`,
          7: '禮品券兌換'
        }
        return `點數使用狀況：${couponTypeObj[transactionData.coupon.type]}`
      }
    },
    pointReset: function (value) {
      return value < 0 ? 0 : value
    },
    getEpisodesTotal: function (episodes) {
      return episodes.length
    }
  }
}
</script>

<style>

/* @import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css'; */

@media screen and (min-width: 576px) {
  .status_wrap {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyTransactionItem/components/TransactionList.vue